import { Validator } from '@vista-digital/validator';
import { defaultFilmTitleCdnOptions, filmTitleCdnOptionsValidator } from './cdn-options';
import { defaultFilmTitleConfig, filmTitleConfigValidator } from './config';
export const defaultFilmTitleProps = {
    config: defaultFilmTitleConfig,
    cdnOptions: defaultFilmTitleCdnOptions
};
export const filmTitlePropsValidator = Validator.object({
    config: filmTitleConfigValidator,
    cdnOptions: filmTitleCdnOptionsValidator
});
